import ProtectedRoute from '../../components/ProtectedRoute';
import CommunityPage from './components/CommunityPage';

import { COMMUNITY_PATH } from '../../constants/routes';

const Routes = [
  {
    path: COMMUNITY_PATH,
    Component: ProtectedRoute,
    children: [
      {
        index: true,
        Component: CommunityPage,
      },
    ],
  },
];

export default {
  Routes,
};
